// extracted by mini-css-extract-plugin
module.exports = {"spinner__white":"Spinner_spinner__white__3eRIv","circleRotation":"Spinner_circleRotation__SEKj_","spinner__primary":"Spinner_spinner__primary__1y5nT"};